// extracted by mini-css-extract-plugin
export default {"productcard":"cB","productimage":"eB","username":"fB","multiBagName":"gB","productinfo":"hB","productinfoinner":"iB","productname":"jB","productsubheader":"kB","productdescription":"lB","productnumbers":"mB","productnumberstitle":"nB","productnumbersitem":"oB","number":"pB","numbertext":"qB","tabs":"rB","benefitsblock":"sB","benefit":"tB","benefitname":"uB","benefitdescription":"vB","ingredientsblock":"wB","tipsblock":"xB","mobileonly":"yB"};
    if(module.hot) {
      // 1714442369226
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  